import WifiElement from './wifi_element';

export default WifiElement;
